export enum ButtonType {
  Primary = 'primary',
  Default = 'default',
  Link = 'link',
}

export enum ButtonAlign {
  Center = 'center',
  Start = 'flex-start',
  End = 'flex-end',
  Full = 'full',
}
